module.exports = __webpack_public_path__ + "assets/img/teacher (33).3a22b321.png";